<dx-popup
    #paymentDetailPopup
    [title]="popUpTitle"
    [showTitle]="true"
    width="55%"
    height="35%"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="adjustment-detail-content">
        <dx-box *ngIf="!!apPaymentDetail" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form
                    width="100%"
                    height="100%"
                    [readOnly]="true"
                    [colCount]="2"
                    [labelLocation]="defaultLabelLocation"
                    [formData]="apPaymentDetail"
                >
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Payment Date"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.paymentDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="isInternalUser">
                        <div class="history-icon" *dxTemplate>
                            <dx-toolbar>
                                <dxi-item
                                    location="after"
                                    widget="dxButton"
                                    [options]="historyButtonOptions"
                                ></dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.postDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Payee"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                actionCode="VENDOR_MANAGEMENT"
                                [displayText]="apPaymentDetail?.vendorName"
                                [communityId]="contextCommunityId"
                                (onLinkClick)="onVendorNameClick()"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="apPaymentDetail.amount === 0">
                                {{ currencyFormatter(apPaymentDetail?.amount) }}
                            </span>
                            <app-hyperlink-creator
                                *ngIf="apPaymentDetail.amount > 0"
                                mode="hyperlinkOnly"
                                [displayText]="currencyFormatter(apPaymentDetail?.amount)"
                                [communityId]="contextCommunityId"
                                (onLinkClick)="showAPCreditApplication()"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="apPaymentDetail?.paymentDocument?.downloadUrl">
                        <dxo-label text="Payment Image"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                textLocation="right"
                                [communityId]="contextCommunityId"
                                [displayText]="apPaymentDetail?.paymentNumber"
                                (onLinkClick)="downloadPaymentDocument(apPaymentDetail?.paymentDocument.fileName)"
                            >
                                <i
                                    class="fa-1x margin-right-3px"
                                    [ngClass]="getFileIconByExtension(apPaymentDetail?.paymentDocument)"
                                ></i>
                            </app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Payment Method"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.paymentMethod }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Bank Account"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.accountName }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Unapplied Amount"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.unappliedAmount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Payment Status"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.status }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Date Cleared / Reconciled"></dxo-label>
                        <div *dxTemplate>
                            {{ apPaymentDetail?.clearDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Voided"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="apPaymentDetail?.voided">Yes</span>
                            <span *ngIf="!apPaymentDetail?.voided">No</span>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="apPaymentDetail?.isReconciled && !apPaymentDetail?.voided">
                        <div *dxTemplate class="cc-text-required">
                            <ng-container>
                                <strong>Note:&nbsp;</strong>
                                Payment was cleared from bank account
                            </ng-container>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item [ratio]="1">
                <dx-toolbar width="100%" class="payment-button-container">
                    <dxi-item
                        location="after"
                        widget="dxButton"
                        [visible]="apPaymentDetail?.allowVoidPayment"
                        [options]="{
                            type: 'default',
                            template: 'voidMultiIconTemplate',
                            text: addVoidButtonOptions,
                            onClick: onVoidClick
                        }"
                    ></dxi-item>
                    <dxi-item
                        location="after"
                        widget="dxButton"
                        [visible]="apPaymentDetail?.allowUpdatePaymentPostDate"
                        [options]="{
                            type: 'default',
                            template: 'paymentPostDateMultiIconTemplate',
                            text: addUpdatePaymentButtonOptions,
                            onClick: onUpdatePaymentPostDate
                        }"
                    ></dxi-item>
                    <dxi-item
                        location="after"
                        widget="dxButton"
                        [visible]="apPaymentDetail?.allowAddCharge"
                        [options]="{
                            type: 'default',
                            template: 'serviceChargeMultiIconTemplate',
                            text: addAddChargeButtonOptions,
                            onClick: onAddChargeClick
                        }"
                    ></dxi-item>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="iconCancel"
                                text="Close"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <app-multi-icon-button-template templateName="voidMultiIconTemplate">
                        <app-security-info
                            iconColor="cc-white-icon"
                            securityIndicator="KEY"
                            apiAction="PUT"
                            apiUrl="api/cb/ap/payment/void"
                        ></app-security-info>
                    </app-multi-icon-button-template>
                    <app-multi-icon-button-template templateName="paymentPostDateMultiIconTemplate">
                        <app-security-info
                            iconColor="cc-white-icon"
                            securityIndicator="KEY"
                            apiAction="PUT"
                            apiUrl="api/cb/ap/payment/postdate"
                        ></app-security-info>
                    </app-multi-icon-button-template>
                    <app-multi-icon-button-template templateName="serviceChargeMultiIconTemplate">
                        <app-security-info
                            iconColor="cc-white-icon"
                            securityIndicator="KEY"
                            apiAction="POST"
                            apiUrl="api/cb/ap/payment/servicecharge"
                        ></app-security-info>
                    </app-multi-icon-button-template>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-void-ap-payment
    *ngIf="showVoidPayment"
    [visible]="showVoidPayment"
    [title]="voidPaymentTitle"
    [communityId]="apPaymentParam?.communityId"
    [managementCompanyId]="apPaymentParam?.managementCompanyId"
    [paymentId]="apPaymentParam?.paymentId"
    (onClose)="onVoidPaymentClose($event)"
></app-void-ap-payment>

<app-ap-payment-post-date-editor
    *ngIf="showPaymentPostDateEditor"
    [title]="updatePaymentTitle"
    [communityId]="apPaymentParam?.communityId"
    [managementCompanyId]="apPaymentParam?.managementCompanyId"
    [paymentId]="apPaymentParam?.paymentId"
    (onClose)="onPaymentPostDateEditorClose($event)"
></app-ap-payment-post-date-editor>

<app-transaction-history
    *ngIf="showTransactionLog"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogs"
    [communityId]="apPaymentParam?.communityId"
    (onTransactionLogClose)="onTransactionLogClose()"
></app-transaction-history>

<app-service-charge-editor
    *ngIf="showAddServiceChargeEditor"
    [visible]="showAddServiceChargeEditor"
    [popUpTitle]="addServiceChargeTitle"
    [serviceChargeParam]="serviceChargeParam"
    [serviceChargeEditorData]="serviceChargeEditorData"
    [subCategories]="subCategories"
    (getSubcategories)="getSubcategories($event)"
    (addServiceCharge)="addAPServiceCharge($event)"
    (closeServiceChargeEditor)="closePopUp()"
></app-service-charge-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#paymentDetailPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-ap-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [transactionId]="apPaymentParam.paymentId"
    [communityId]="apPaymentParam.communityId"
    [popupTitle]="creditApplicationTitle"
    [managementCompanyId]="apPaymentParam.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ap-credit-application>
